// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"c7332c86","238":"b7b3e1f8","455":"d2b33bf9","644":"8c4c110f","865":"f7638cea"}[chunkId] + ".chunk.js";
};